export const PILL_HEIGHT = '52px'
export const FILTER_AND_SORT_BUTTON_WIDTH = '182px'
export const SAVE_SEARCH_BUTTON_HEIGHT = '20px'
export const SAVE_SEARCH_BUTTON_WIDTH = '120px'
